export default "<div [hidden]=\"!showError\">\n\t<span style=\"color: red\" >{{message}}</span>\n</div>"